import { render, staticRenderFns } from "./TransactionRow.vue?vue&type=template&id=61b31eb3&scoped=true&"
import script from "./TransactionRow.vue?vue&type=script&lang=js&"
export * from "./TransactionRow.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRow.vue?vue&type=style&index=0&id=61b31eb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b31eb3",
  null
  
)

export default component.exports